import React, { useEffect, useState } from "react";
import { loadStripe, Stripe, StripeElements } from "@stripe/stripe-js";
import { CardNumberElement } from "@stripe/react-stripe-js";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import "./SupplementCheckout.css";
import CheckedMark from "../../assets/images/checked_mark.png";
import DeliveryIcon from "../../assets/images/Delivery-icon.png";
import couponImage from "../../assets/images/couponIcon.png";
import EmpoweredBundle from "../../assets/images/Empowered-bundle.png";
import ArrowUp from "../../assets/images/arrow-up.png";
import ArrowDown from "../../assets/images/arrow-down.png";
import {
  createSupplementUser,
  supplementChargeBundle,
  validateCoupon,
} from "../../services/api";
import { useNavigate } from "react-router-dom";
import CheckoutFormWrapper from "../../components/CheckoutForm/CheckoutFormWrapper";

const isProd = process.env.REACT_APP_ENV === "production";
const key = isProd
  ? "pk_live_51PsWA5GejApNyv7Xuy48c50fEyWxIqSglHCR33zJQNzXYUG4DHu4hpbRM80SVkXNrSPgimj1ioe3cVabLPjgN3bh00GkcYUa3H"
  : "pk_test_51PsWA5GejApNyv7Xdo7ye2sTXDMhrfaFsd15JKinSzBWaSR3iqAwTgEkbm9ZCPzit4RpxVotpvaPScTPiwwjG1ht00qiPluAWx";
const stripePromise = loadStripe(key);

const SupplementCheckout = () => {
  const [formState, setFormState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    billingAddressAddressLine1: "",
    billingAddressAddressLine2: "",
    billingAddressCity: "",
    billingAddressState: "",
    billingAddressZip: "",
    country: "",
    postcode: "",
    isCheckedTerms: false,
    firstNameError: "",
    lastNameError: "",
    emailError: "",
    phoneError: "",
    addressLine1Error: "",
    cityError: "",
    stateError: "",
    zipError: "",
    billingAddressAddressLine1Error: "",
    billingAddressCityError: "",
    billingAddressStateError: "",
    billingAddressZipError: "",
    isSubscribed: false,
    isChecked: false,
    isVariant: localStorage.getItem("isVariant") === "true",
    isCardValid: false,
    error: "",
    loading: false,
  });
  const navigate = useNavigate();
  const [isCardNumberValid, setIsCardNumberValid] = useState(false);
  const [isCardExpiryValid, setIsCardExpiryValid] = useState(false);
  const [isCardCvcValid, setIsCardCvcValid] = useState(false);
  const isCardValid = isCardNumberValid && isCardExpiryValid && isCardCvcValid;
  const [finalAmount, setFinalAmount] = useState<number | null>(147);
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [couponCode, setCouponCode] = useState<string>("");
  const [isCouponApplied, setIsCouponApplied] = useState<boolean>(false);
  const [wrongCoupon, setWrongCoupon] = useState<boolean>(false);
  const [showDiscountlabel, setShowDiscountLabel] = useState(false);
  const [couponDiscountValue, setCouponDiscountValue] = useState<number | null>(
    null
  );
  const [stripeInstance, setStripeInstance] = useState<Stripe | null>(null);
  const [elementsInstance, setElementsInstance] =
    useState<StripeElements | null>(null);

  const handleStripeReady = (
    stripe: Stripe | null,
    elements: StripeElements | null
  ) => {
    setStripeInstance(stripe);
    setElementsInstance(elements);
  };
  const [uuidValue, setUuidValue] = useState<string>("");
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);
  const isProd = process.env.REACT_APP_ENV === "production";
  let bundlePriceId = "";
  let productId = "";
  if (isProd) {
    bundlePriceId = "price_1QsGObGejApNyv7XyX7uqWEo";
    productId = "prod_Rlo01ObwHxZeio";
  } else {
    bundlePriceId = "price_1Qmi68GejApNyv7XLjdlvE7D";
    productId = "prod_Rg4EUk6WDgl67a";
  }


  const openSiteLock = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.open(
      "https://www.sitelock.com/verify.php?site=claya.com",
      "SiteLock",
      "width=600,height=600,left=160,top=170"
    );
  };

  const formatPhoneNumber = (value: string): string => {
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 3) return `(${cleaned}`;
    if (cleaned.length <= 6)
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
      6,
      10
    )}`;
  };

  const handleChange = (field: string, value: string) => {
    setFormState((prev) => {
      const updatedState = { ...prev, [field]: value };
      const errors: Partial<typeof prev> = {};

      const isEmpty = (val: string) => val.trim() === "";

      switch (field) {
        case "firstName":
          errors.firstNameError = isEmpty(value)
            ? "Please enter your first name"
            : "";
          break;
        case "lastName":
          errors.lastNameError = isEmpty(value)
            ? "Please enter your last name"
            : "";
          break;
        case "email":
          errors.emailError = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
            ? "Please enter a valid email"
            : "";
          break;
        case "phone":
          if (value.replace(/\D/g, "").length > 10) return prev;
          errors.phoneError =
            value.replace(/\D/g, "").length !== 10
              ? "Please enter a valid 10-digit phone number"
              : "";
          updatedState.phone = formatPhoneNumber(value); // formatted like (123) 456-7890
          break;
        case "addressLine1":
          errors.addressLine1Error = isEmpty(value)
            ? "Please enter your Address Line 1"
            : "";
          break;
        case "city":
          errors.cityError = isEmpty(value) ? "Please enter your city" : "";
          break;
        case "state":
          errors.stateError = isEmpty(value) ? "Please enter your state" : "";
          break;
        case "zip":
          errors.zipError = isEmpty(value)
            ? "Please enter your zip code"
            : value.length > 5
            ? "Zip code cannot exceed 5 digits"
            : "";
          if (value.length > 5) return prev;
          break;
        case "billingAddressAddressLine1":
          errors.billingAddressAddressLine1Error = isEmpty(value)
            ? "Please enter your Address Line 1"
            : "";
          break;
        case "billingAddressCity":
          errors.billingAddressCityError = isEmpty(value)
            ? "Please enter your city"
            : "";
          break;
        case "billingAddressState":
          errors.billingAddressStateError = isEmpty(value)
            ? "Please enter your state"
            : "";
          break;
        case "billingAddressZip":
          errors.billingAddressZipError = isEmpty(value)
            ? "Please enter your zip"
            : value.length > 5
            ? "Zip code cannot exceed 5 digits"
            : "";
          if (value.length > 5) return prev;
          break;
        case "isSubscribed":
          updatedState.isSubscribed = Boolean(value);
          break;

        case "isCheckedTerms":
          updatedState.isCheckedTerms = Boolean(value);
          break;
        default:
          break;
      }

      return {
        ...updatedState,
        ...errors,
      };
    });
  };

  const toggleCouponInput = () => {
    setShowCouponInput((prev) => !prev);
  };

  const handleCardNumberChange = (event: { complete: boolean }) => {
    setIsCardNumberValid(event.complete);
  };

  const handleCardExpiryChange = (event: { complete: boolean }) => {
    setIsCardExpiryValid(event.complete);
  };

  const handleCardCvcChange = (event: { complete: boolean }) => {
    setIsCardCvcValid(event.complete);
  };

  const handleChangeState = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    handleChange("state", value);
  };

  const handleChangeBillingState = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value;
    handleChange("billingAddressState", value);
  };

  const stateOptions: Record<string, string> = {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming",
  };

  const handleCheckboxChange = () => {
    setFormState((prev) => {
      const isCheckedNow = !prev.isChecked;

      return {
        ...prev,
        isChecked: isCheckedNow,
        ...(isCheckedNow
          ? {
              billingAddressAddressLine1: "",
              billingAddressAddressLine2: "",
              billingAddressCity: "",
              billingAddressState: "",
              billingAddressZip: "",
            }
          : {
              billingAddressAddressLine1: prev.addressLine1,
              billingAddressAddressLine2: prev.addressLine2,
              billingAddressCity: prev.city,
              billingAddressState: prev.state,
              billingAddressZip: prev.zip,
            }),
      };
    });
  };

  const ProductPoint = ({
    title,
    description,
  }: {
    title: string;
    description: string;
  }) => (
    <div className="post-checkout-product-points">
      <img src={CheckedMark} alt="checked_mark" className="product-checked-mark"/>
      <div className="product-point">
        <p>{title} </p>
        <span>{description}</span>{" "}
      </div>
    </div>
  );

  const CheckoutProductDetails = () => {
    const productPoints = [
      {
        title: "Balance",
        description: "Essential magnesium for energy and calm.",
      },
      { title: "Sync", description: "Improves metabolism and fat regulation" },
      {
        title: "Nourish ",
        description: "Pure plant-powered protein for muscle maintenance",
      },
      {
        title: "Renew ",
        description: "Advanced antioxidant support during rapid weight loss",
      },
    ];

    return (
      <div className="post-checkout-product-details">
        {productPoints.map((point, index) => (
          <ProductPoint
            key={index}
            title={point.title}
            description={point.description}
          />
        ))}
      </div>
    );
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormState((prev) => ({ ...prev, loading: true, error: "" }));

    if (!stripeInstance || !elementsInstance) {
      setFormState((prev) => ({
        ...prev,
        error: "Stripe is not ready. Please refresh the page.",
        loading: false,
      }));
      return;
    }

    const cardNumberElement = elementsInstance.getElement(CardNumberElement);
    if (!cardNumberElement) {
      setFormState((prev) => ({
        ...prev,
        error: "Card number element not found.",
        loading: false,
      }));
      return;
    }

    try {
      const { paymentMethod, error } = await stripeInstance.createPaymentMethod(
        {
          type: "card",
          card: cardNumberElement,
          billing_details: {
            email: formState.email,
            name: formState.firstName,
          },
        }
      );

      if (error) {
        throw new Error(error.message || "Payment method creation failed.");
      }

      // Create Supplement User
      const supplementUserData = await createSupplementUser(
        formState.firstName,
        formState.lastName,
        formState.email,
        formState.phone,
        formState.addressLine1,
        formState.addressLine2,
        formState.city,
        formState.state,
        formState.zip,
        uuidValue
      );

      if (!supplementUserData || supplementUserData.error) {
        throw new Error(
          supplementUserData?.error || "Failed to create supplement user."
        );
      }

      // Create Subscription
      const URL = isProd
        ? "https://claya-ruby-b715fff96163.herokuapp.com"
        : "https://claya-stage-ruby-03e61b6e8c6b.herokuapp.com";

      const response = await fetch(
        `${URL}/api/v1/patients/payments/create_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: formState.email,
            first_name: formState.firstName,
            last_name: formState.lastName,
            payment_method_id: paymentMethod.id,
            price_id: bundlePriceId,
            isSupplemented: true,
            uuid: uuidValue,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.error || "Subscription creation failed");
      }

      const { customer_id } = data;

      const chargeRes = await supplementChargeBundle(
        couponCode,
        bundlePriceId,
        formState.email,
        formState.firstName,
        formState.lastName,
        formState.phone,
        paymentMethod.id,
        customer_id
      );

      if (!chargeRes.success) {
        throw new Error("Failed to charge bundle.");
      }

      navigate("/supplement-checkout/thank-you");
    } catch (err: any) {
      console.error("Checkout error:", err);
      setFormState((prev) => ({
        ...prev,
        error: err.message || "Something went wrong during checkout.",
      }));
    } finally {
      setFormState((prev) => ({ ...prev, loading: false }));
    }
  };
  const ProductDetails = () => {
    const points = [
      { percent: "15%", content: "Faster weight loss" },
      { percent: "99%", content: "users see results in 3 months" },
      { percent: "93%", content: "Patients kept weight off" },
    ];

    return (
      <div className="checkout-supplement-product-points">
        {points.map((point, index) => (
          <div className="checkout-product-point" key={index}>
            <div className="product-percent">{point.percent}</div>
            <div className="product-content">{point.content}</div>
          </div>
        ))}
      </div>
    );
  };

  const applyCoupon = async () => {
    if (couponCode && !showDiscountlabel) {
      try {
        setLoading1(true);
        // Get the correct product Id based on selected plan
        const totalPrice = "147";
        const response = await validateCoupon(
          couponCode,
          totalPrice,
          productId
        );
        if (response.valid) {
          setIsCouponApplied(true);
          setFinalAmount((prev) =>
            prev !== null ? prev - response?.discount : null
          );
          setShowDiscountLabel(true);
          setWrongCoupon(false);
          setCouponDiscountValue(response?.discount);
        } else {
          setWrongCoupon(true);
        }
      } catch (error) {
        console.error("Error validating coupon:", error);
        setWrongCoupon(true);
        setLoading1(false);
      } finally {
        setLoading1(false);
      }
    }
  };

  const removeCoupon = () => {
    setIsCouponApplied(false);
    setCouponCode("");
    localStorage.setItem("promoCode", "");

    setFinalAmount((prev) =>
      prev !== null ? prev + (couponDiscountValue || 0) : null
    );
    setCouponDiscountValue(0);
    setShowDiscountLabel(false);
  };

  useEffect(() => {
    if (isCouponApplied) {
      setIsCouponApplied(true);
    }
  }, [isCouponApplied]);
  const handleCouponCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
    setWrongCoupon(false);
  };
  return (
    <PageWrapper>
      <div className="signup-page-container">
        <div className="checkout-container">
          <h1 className="checkout-header">
            Maximize the benefits of GLP-1s with
            <p className="checkout-header-highlight">
              EMPOWERED FOUNDATION BUNDLE
            </p>
          </h1>
          <div className="checkout-supplement">
            <div className="checkout-supplement-section-1">
              <img
                className="checkout-supplement-img"
                src={EmpoweredBundle}
                alt="EmpoweredBundle"
              />
              <div className="checkout-supplement-content">
                <h1 className="checkout-supplement-title">
                  Empowered Foundation Bundle
                </h1>
                <div className="post-checkout-product-price">
                  <p className="product-actual-price">$347</p>
                  <p className="product-offer-price">$147</p>
                  <p>
                    <span className="product-offer-label">60% OFF</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="checkout-supplement-section-2">
              <h1 className="checkout-supplement-question">
                What you get in the bundle:
              </h1>
              <CheckoutProductDetails />
              <div className="checkout-order-delivery mobile">
                  <img
                    className="checkout-order-delivery-icon"
                    src={DeliveryIcon}
                    alt="delivery-icon"
                  />
                  <p className="checkout-order-delivery-text">
                    Delivered to your doorstep every month
                  </p>
                </div>
            </div>
          </div>
          <ProductDetails />
          <div className="checkout-order-summary">
            <h3 className="checkout-order-summary-header">Order Summary</h3>
            <div className="checkout-order-summary-content">
              <img
                className="checkout-order-summary-img"
                src={EmpoweredBundle}
                alt="EmpoweredBundle"
              />
              <div className="checkout-order-summary-sidecontent">
                <p className="checkout-order-summary-title">
                  EMPOWERED FOUNDATION BUNDLE
                </p>
                <div className="post-checkout-product-price-mobile">
                  <p className="product-actual-price">$347</p>
                  <p className="product-offer-price">$147</p>
                  <p>
                    <span className="product-offer-label">60% OFF</span>
                  </p>
                </div>
                <div className="checkout-order-delivery">
                  <img
                    className="checkout-order-delivery-icon"
                    src={DeliveryIcon}
                    alt="delivery-icon"
                  />
                  <p className="checkout-order-delivery-text">
                    Delivered to your doorstep every month
                  </p>
                </div>
              </div>
            </div>
            <div className="checkout-order-delivery-mobile">
              <img
                className="checkout-order-delivery-icon"
                src={DeliveryIcon}
                alt="delivery-icon"
              />
              <p className="checkout-order-delivery-text">
                Delivered to your doorstep every month
              </p>
            </div>
            <div className="coupon-toggle-container">
              <div className="coupon-toggle-header" onClick={toggleCouponInput}>
                <span className="coupon-text">Coupon code</span>
                <span className="coupon-arrow-icon">
                  {showCouponInput ? (
                    <img src={ArrowUp} alt="arrow-up" />
                  ) : (
                    <img src={ArrowDown} alt="arrow-down" />
                  )}
                </span>
              </div>

              {showCouponInput && (
                <div className="coupon-input-wrapper">
                  <input
                    type="text"
                    value={couponCode}
                    onChange={handleCouponCodeChange}
                    placeholder="Discount Code or gift card"
                    className="coupon-input"
                  />
                  <button
                    disabled={loading1 || showDiscountlabel}
                    type="button"
                    onClick={applyCoupon}
                    className="apply-coupon-btn"
                    style={{
                      backgroundColor: showDiscountlabel
                        ? "#0C3972"
                        : "#E5EDF6",
                      color: showDiscountlabel ? "#fff" : "#000",
                    }}
                  >
                    {showDiscountlabel ? "Applied" : "Apply"}
                  </button>
                </div>
              )}
              {showDiscountlabel && (
                <div className="applied-coupon">
                  <img
                    src={couponImage}
                    alt="Coupon Icon"
                    style={{ width: "13px", height: "12.48px" }}
                  />
                  <span style={{ fontSize: "12px" }}>Coupon Applied</span>
                  <button
                    type="button"
                    onClick={removeCoupon}
                    className="remove-coupon-btn"
                  >
                    X
                  </button>
                </div>
              )}
              {wrongCoupon && (
                <p className="error-message" style={{ textAlign: "left" }}>
                  Invalid coupon code. Please try again.
                </p>
              )}
            </div>

            <hr className="checkout-order-summary-line" />
            <div className="checkout-order-summary-total-price">
              <p className="checkout-order-summary-total">Total</p>
              <p className="checkout-order-summary-price">${finalAmount}</p>
            </div>
          </div>
          <div>
            <div className="payment-section">
              <CheckoutFormWrapper
                stripePromise={stripePromise}
                onStripeReady={handleStripeReady}
                {...formState}
                onChange={handleChange}
                onSubmit={handleSubmit}
                onCardNumberChange={handleCardNumberChange}
                onCardExpiryChange={handleCardExpiryChange}
                onCardCvcChange={handleCardCvcChange}
                isCardValid={isCardValid}
                handleChangeState={handleChangeState}
                handleChangeBillingState={handleChangeBillingState}
                onCheckboxChange={handleCheckboxChange}
                stateOptions={stateOptions}
              />
            </div>
          </div>
          <div className="policy" >
          <a
                href="https://claya.com/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            
             <a
                href="https://claya.com/terms-of-use/"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Use
              </a>
              <a
                href="https://claya.com/cancellation-and-refund-policy/"
                target="_blank"
                rel="noreferrer"
              >
                Cancellation and Refund Policy 
              </a>
              <a
                href="https://claya.com/important-safety-information-page/"
                target="_blank"
                rel="noreferrer"
              >
                Safety Page 
              </a>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <a href="#" onClick={openSiteLock}>
              <img
                className="img-fluid"
                alt="SiteLock"
                title="SiteLock"
                src="https://shield.sitelock.com/shield/claya.com"
              />
            </a>
          </div>

          <div className="help-box help-box-container">
            <div className="help-text-ele">
              <h2 className="help-font">Need Help?</h2>
              <div className="adjust-dot-text">
                <div className="dot">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <circle cx="9" cy="9.63965" r="6" fill="#00B57A" />
                    <circle
                      cx="9"
                      cy="9.63965"
                      r="7.5"
                      stroke="#00B57A"
                      strokeOpacity="0.15"
                      strokeWidth="3"
                    />
                  </svg>
                </div>
                <span className="available-text">
                  Available{" "}
                  <span className="available-timings">8 AM – 8 PM ET</span>
                </span>
              </div>
            </div>
            <div></div>
            <div className="contact-ele">
              <div className="phone-img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1419_1009)">
                    <path
                      d="M8.20312 0.139821C11.9561 0.139821 15 3.18377 15 6.93669C15 7.32634 14.6865 7.63982 14.2969 7.63982C13.9072 7.63982 13.5938 7.32634 13.5938 6.93669C13.5938 3.96013 11.1797 1.54607 8.20312 1.54607C7.81348 1.54607 7.5 1.23259 7.5 0.842946C7.5 0.453297 7.81348 0.139821 8.20312 0.139821ZM8.4375 5.76482C8.95518 5.76482 9.375 6.18464 9.375 6.70232C9.375 7.22 8.95518 7.63982 8.4375 7.63982C7.91982 7.63982 7.5 7.22 7.5 6.70232C7.5 6.18464 7.91982 5.76482 8.4375 5.76482ZM7.5 3.65544C7.5 3.2658 7.81348 2.95232 8.20312 2.95232C10.4033 2.95232 12.1875 4.7365 12.1875 6.93669C12.1875 7.32634 11.874 7.63982 11.4844 7.63982C11.0947 7.63982 10.7812 7.32634 10.7812 6.93669C10.7812 5.51287 9.62695 4.35857 8.20312 4.35857C7.81348 4.35857 7.5 4.04509 7.5 3.65544ZM3.44238 0.180836C4.01074 0.0255629 4.60547 0.315602 4.83105 0.860524L6.00293 3.67302C6.20215 4.15056 6.06445 4.70427 5.66309 5.02947L4.21875 6.21306C5.19434 8.27556 6.86426 9.94548 8.92676 10.9211L10.1074 9.47673C10.4355 9.07537 10.9863 8.93767 11.4639 9.13689L14.2764 10.3088C14.8213 10.5343 15.1113 11.1291 14.9561 11.6974L14.2529 14.2756C14.1152 14.7853 13.6523 15.1398 13.125 15.1398C5.87695 15.1398 0 9.26287 0 2.01482C0 1.48748 0.354492 1.02459 0.864258 0.883961L3.44238 0.180836Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1419_1009">
                      <rect
                        width="15"
                        height="15.0006"
                        fill="white"
                        transform="translate(0 0.139404)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h2 className="phone-number">+1 (415) 980-4031</h2>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SupplementCheckout;
